import { ResourcesState } from './types';
import { RootState } from 'store/reducer';
import { createSelector } from 'reselect';

export const resourcesState = (state: RootState): ResourcesState => state.resources;

export const selectResources = createSelector([resourcesState], resources => resources.resources);

export const selectResourcesAmount = createSelector([resourcesState], resources => resources?.resources?.length);

export const selectGetResourcesLoadingStatus = createSelector([resourcesState], resources => resources.loading);

export const selectInfiniteResources = createSelector([resourcesState], resources => resources.infiniteResources);

export const selectHasMoreInfiniteResources = createSelector(
  [resourcesState],
  resources => resources.hasMoreInfiniteResources,
);

export const selectGetInfiniteResourcesStatus = createSelector(
  [resourcesState],
  resources => resources.getInfiniteResources,
);

export const selectResourcesLocations = createSelector([selectResources], resources => {
  const selectedLocations = resources?.map(resource => {
    const { coordinates, ...rest } = resource.location || {};

    return {
      ...rest,
      latitude: coordinates?.latitude,
      longitude: coordinates?.longitude,
    };
  });
  const uniqKey = 'id';

  return [...new Map(selectedLocations?.map(location => [location?.[uniqKey], location])).values()];
});

export const selectInfiniteResourcesTotal = createSelector([resourcesState], resources => resources.total);

export const selectResourcesDiscountByUuid = (uuid: string) =>
  createSelector([selectResources], resources => {
    if (!Array.isArray(resources)) {
      return null;
    }

    for (const resource of resources) {
      const foundDiscount = resource?.discounts?.find(discount => discount?.uuid === uuid);
      if (foundDiscount) {
        return foundDiscount;
      }
    }

    return null;
  });
